import { render, staticRenderFns } from "./DetailsDsCardCoupons.vue?vue&type=template&id=2c51f65a&scoped=true&"
import script from "./DetailsDsCardCoupons.vue?vue&type=script&lang=js&"
export * from "./DetailsDsCardCoupons.vue?vue&type=script&lang=js&"
import style0 from "./DetailsDsCardCoupons.vue?vue&type=style&index=0&id=2c51f65a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c51f65a",
  null
  
)

export default component.exports